import { ConsoleRequest, DataProviderType } from '../../utils/request';
import { BaseWebComponentDataProvider } from '../../framework/BaseWebComponentDataProvider';
import { UpdatedAccount } from '../editAccount/types';
import { NewAccount } from '../addAccount/types';

export class AccountDataProvider extends BaseWebComponentDataProvider {
  public async updateRecords(records: Array<UpdatedAccount>): Promise<any> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'Users',
      method: 'updateRecords',
      payload: {
        records: records,
      },
    });
  }

  public async createRecords(records: NewAccount[]): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'Users',
      method: 'createRecords',
      payload: {
        records: records,
      },
    });
  }
}
